var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('cube-page',{attrs:{"type":"myorder-view","title":"核销列表"}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_vm._v("\n\t\t\t 核销列表\n\t\t")])]),_c('cube-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }